export interface ClinicImage {
    name: string;
    downloadUrl: string;
}

export interface CarouselItem {
    image: string;
    imageAltText: string;
}

// Image types for clinic carousel, in order of preference
export const CLINIC_IMAGE_TYPES = [
    'thumbnail',
    'frontdesk',
    'lobby',
    'consultationroom',
    'txroom',
    'frontdoor',
] as const;

// Maps clinic image names to their types by extracting from filename
export function mapClinicImagesByType(clinicImages: ClinicImage[]): Record<string, string> {
    const mappedImages: Record<string, string> = {};

    clinicImages.forEach(({ name, downloadUrl }) => {
        const mappedName = name.split('_')[1]?.split('.')[0]?.toLowerCase();
        if (mappedName) {
            mappedImages[mappedName] = downloadUrl;
        }
    });

    return mappedImages;
}

// Processes clinic images to create carousel items with fallback
export function processClinicImagesForCarousel(
    clinicImages: ClinicImage[],
    locationName: string | null,
    fallbackImage: string = '/assets/images/milan-front-door.webp',
    customAltText?: string
): CarouselItem[] {
    const mappedImages = mapClinicImagesByType(clinicImages);

    const specificImages = CLINIC_IMAGE_TYPES.map((imageType) => mappedImages[imageType]).filter(Boolean);

    const uniqueImages = Array.from(new Set(specificImages));

    const altText =
        customAltText ||
        (locationName ? `Milan Laser Hair Removal Clinic in ${locationName}` : 'Milan Laser Hair Removal Clinic');

    const finalCarouselItems: CarouselItem[] =
        uniqueImages.length > 0
            ? uniqueImages.map((clinicImage) => ({
                  image: clinicImage,
                  imageAltText: altText,
              }))
            : [
                  {
                      image: fallbackImage,
                      imageAltText: altText,
                  },
              ];

    return finalCarouselItems;
}
